/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class JobSucceededNotificationArguments {
  /**
  * The id of the job
  */
  'id'?: string;
  /**
  * The start time of the job
  */
  'startTime'?: Date;
  /**
  * The end time of the job
  */
  'endTime'?: Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "startTime",
      "baseName": "startTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "endTime",
      "baseName": "endTime",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return JobSucceededNotificationArguments.attributeTypeMap;
  }

  public constructor() {
  }
}

